export default function getDisplayType(linkItem) {
  return linkItem && linkItem.type || 'browser';
}